import script from "./FooterLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLinks.vue?vue&type=script&setup=true&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=352ee79f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352ee79f"]])

export default __exports__